/**
 * Song Creation & Editor Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Song Editor guide.
 */
export const songEditorTourConfig = {
  id: 'song-editor-onboarding',
  storageKey: 'triad_tour_song_editor_completed',
  steps: [
    {
      id: 'song-ai-tools',
      target: '[data-tour="song-ai-tools"]',
      titleKey: 'tour.songEditor.aiTitle',
      descriptionKey: 'tour.songEditor.aiDesc',
      position: 'bottom',
      align: 'start',
      allowMissing: true
    },
    {
      id: 'song-info-fields',
      target: '[data-tour="song-info-fields"]',
      titleKey: 'tour.songEditor.infoTitle',
      descriptionKey: 'tour.songEditor.infoDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'song-bpm-tempo',
      target: '[data-tour="song-bpm-tempo"]',
      titleKey: 'tour.songEditor.tempoTitle',
      descriptionKey: 'tour.songEditor.tempoDesc',
      position: 'top',
      align: 'start'
    },
    {
      id: 'song-editor-area',
      target: '[data-tour="song-editor-area"]',
      titleKey: 'tour.songEditor.editorTitle',
      descriptionKey: 'tour.songEditor.editorDesc',
      position: 'top',
      align: 'center'
    },
    {
      id: 'song-save-btn',
      target: '[data-tour="song-save-btn"]',
      titleKey: 'tour.songEditor.saveTitle',
      descriptionKey: 'tour.songEditor.saveDesc',
      position: 'bottom',
      align: 'end'
    }
  ]
};

export default songEditorTourConfig;
